import { useMemo, useSyncExternalStore } from 'react';
import { JsonPointerPath } from 'types/dynamic-forms/JsonPointerPath';
import { useDocumentStore } from './useDocumentStore';

export default function useHasError(path: JsonPointerPath): boolean {
  const store = useDocumentStore();

  const callbacks = useMemo(() => {
    return {
      getState: () => {
        const state = store.getErrorMessagesIncludingNested(path);
        return hasAny(state);
      },
    };
  }, [store, ...path]);
  const state = useSyncExternalStore(store.addDataChangedListener, callbacks.getState);

  return state;
}

function hasAny<T>(iterable: Iterable<T>): boolean {
  for (const _ of iterable) {
    return true;
  }
  return false;
}
